<oui-dialog-content class="dialog-content">
  <oui-button class="dialog-close-btn" type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
  <img class="dialog-image image-width" alt="" src="assets/images/signature_valid.svg" />

  <div class="headline-6">
    Super nouvelle, <br />
    vous continuez avec nous !
  </div>
  <span class="text-md">
    Merci pour votre confiance, nous sommes heureux de poursuivre cette collaboration
    ensemble. <br />
    <br />Un e-mail de confirmation de votre choix a été envoyé à votre boîte de
    réception. Nous sommes impatients de continuer à travailler avec vous sur de nouveaux
    projets !
  </span>
</oui-dialog-content>
